// import { HubConnectionBuilder } from "@microsoft/signalr";
// import { CALL_URL } from "./constants";
// import { signalRHttp } from "./SignalRHttp";


// export  const callConnection: any = new HubConnectionBuilder()
// .withUrl(CALL_URL, {  headers: { "cookie": " " } ,httpClient: new signalRHttp()  })
// .withAutomaticReconnect()
// .build();

import { HubConnectionBuilder } from "@microsoft/signalr";
import { CALL_URL } from "./constants";

const getToken = () => localStorage.getItem("token") || "";

export const callConnection:any = new HubConnectionBuilder()
  .withUrl(CALL_URL, {
    accessTokenFactory: () => getToken()   
  })
  .withAutomaticReconnect([0, 2000, 10000, 30000])
  //.configureLogging(signalR.LogLevel.Information)
  .build();